
import React, { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface NavbarContainerProps {
  children: ReactNode;
  isScrolled?: boolean;
  className?: string;
}

const NavbarContainer = ({
  children,
  isScrolled = false,
  className
}: NavbarContainerProps) => {
  return (
    <header
      className={cn(
        "sticky top-0 z-40 w-full transition-all duration-200",
        isScrolled 
          ? "bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80 border-b border-border shadow-sm" 
          : "bg-background",
        className
      )}
    >
      <div className="container flex h-16 items-center px-4 sm:px-6">
        {children}
      </div>
    </header>
  );
};

export default NavbarContainer;
